<template>
  <div id="app" v-on:user:login="login">
    <div id="wrapper">
      <!-- Sidebar -->
      <MenuSideBar :width=12 :userLogged="userLogged" />    

      <!-- Page Content -->
      <div class="page-content-wrapper">
          <router-view/>
      </div>

      
    </div>    
  </div>      
</template>

<script>
import MenuSideBar from './components/MenuSideBar.vue';
import loginService from "./services/LoginService";
export default {
  name: 'App',
  components: {
    MenuSideBar
  },
  data() {
    return {
      userLogged : false
    };
  },  
  methods: {
    login() {            
      this.userLogged = true;
    },
    logout() {
      this.userLogged = false;
    }    
  },
  mounted() {
    this.userLogged = loginService.isLoggedIn();
  }, 
  beforeUpdate() {
    this.userLogged = loginService.isLoggedIn();
  },    
}
</script>

<style>
#app {
  font-family: "Metropolis", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";  
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5; 
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;  
}
#wrapper {
    display: flex !important;
    width: 100%;
}
.page-content-wrapper {
  width: 100vw;
  text-align: center;
  margin: 1.5rem;
  margin-top: 5rem;
}
</style>
